import {
  Grid,
  GridColumn as Column,
  GridToolbar,
} from "@progress/kendo-react-grid";
import { MDBCol, MDBContainer, MDBRow } from "mdbreact";
import React from "react";
import DropDownDestinationPort from "./DropDownDestinationPort";
import dayjs from "dayjs";
import { DropDownTimeZoneCell } from "./DropDownTimeZoneCell";
import DropDownTimePicker from "./DropDownTimePicker";
import ETADTXDDatePicker from "./ETADTXDDatePicker";
import { EtaDtXdHeader, EtaTmXdHeader } from "./EtaDtXdHeader";
import { process } from "@progress/kendo-data-query";
import ExportData from "../../CommonComponents/ExcelExport";
import { read } from "xlsx";
import {
  BulkUploadData,
  retriggerItems,
  updateItem,
} from "../../../Services/ComponentBasedServices/xDockReportService";
import { toast } from "react-toastify";
import { MyCommandCell } from "./myCommandCell";
import { diff } from "./ObjectDifference";
// import BlockUi from 'react-block-ui'
import { Spinner } from 'reactstrap'

const editField = "inEdit";

function XDOCKReportNew({ props }) {
  const {
    xDOCKReportData: propsData,
    back: backToRearch,
    handleClick: refreshTableData,
    ParentScac: scacSelected,
    timeZoneList,
    destinationDropdownList,
    userDetails
  } = props;

  // Table States
  const [dataState, setDataState] = React.useState({
    skip: 0,
    take: 25,
  });
  const [initialPropsDateModified, setInitialPropsDateModified] =
    React.useState([]);
  const [result, setResult] = React.useState(null);

  // Export states
  const _exporter = React.createRef();

  // File upload States
  const [uploadExcelShow, setUploadExcelShow] = React.useState(false);
  const [selectedFile, setSelectedFile] = React.useState("");
  const [fileData, setFileData] = React.useState("");
  const [base64Data, setBase64Data] = React.useState("");
  const [timeZoneValue, setTimeZoneValue] = React.useState([]);

  // Loading Functionality
  const [block, setBlock] = React.useState(false);

  React.useEffect(() => {
    // let newItems = getItems()
    let _data = [];
    propsData.forEach((ele, index) => {
      _data[index] = {
        ...ele,
        HAWB: ele["HAWB"] ? ele["HAWB"] : "",
        SCAC: ele["SCAC"] ? ele["SCAC"] : "",
        MAWB: ele["MAWB"] ? ele["MAWB"] : "",
        // FLIGHTNO: ele['FLIGHTNO'] ? ele['FLIGHTNO'] : '',
        // ETA_DT_FL: ele['ETA_DT_FL'] ? new Date(ele['ETA_DT_FL']) : '',
        // ETA_TM_FL: ele['ETA_TM_FL'] ? ele['ETA_TM_FL'] : '',
        DES_LOC_PORT: ele["DES_LOC_PORT"] ? ele["DES_LOC_PORT"] : "",
        WGT: ele["WGT"] ? Number(ele["WGT"]).toFixed(2).toString() : "",
        WGT_TYPE: "KG",
        TZONE: ele["TZONE"] ? ele["TZONE"] : "",
        ETA_DT_XD: ele["ETA_DT_XD"] ? new Date(ele["ETA_DT_XD"]) : "",
        ETA_TM_XD: ele["ETA_TM_XD"]
          ? dayjs()
              .set("hour", parseInt(ele["ETA_TM_XD"].split(":")[0]))
              .set("minute", parseInt(ele["ETA_TM_XD"].split(":")[1]))
              .set("second", parseInt(ele["ETA_TM_XD"].split(":")[2]))
          : "",
        REMARKS: ele["REMARKS"] ? ele["REMARKS"] : "",
      };
    });

    setResult(
      process(
        _data.map((dataItem) => Object.assign({ selected: false }, dataItem)),
        dataState
      )
    );
    setInitialPropsDateModified(_data);
    
    let temp = [];
    propsData.forEach((ele) => {
      temp.push({[ele["DES_LOC_PORT"]]: ele["TZONE"] ? ele["TZONE"] : ""})
    })
    setTimeZoneValue(temp)
    
  }, [propsData]);

  const onDataStateChange = (event) => {
    setDataState(event.dataState);
    setResult(
      process(
        initialPropsDateModified.map((dataItem) =>
          Object.assign({ selected: false }, dataItem)
        ),
        event.dataState
      )
    );
  };

  const selectionChange = (event) => {
    const data = result.data.map((item) => {
      if (item.HAWB === event.dataItem.HAWB) {
        item.selected = !event.dataItem.selected;
      }
      return item;
    });
    setResult({ ...result, data });
  };

  const headerSelectionChange = (event) => {
    const checked = event.syntheticEvent.target.checked;
    const data = result.data.map((item) => {
      item.selected = checked;
      return item;
    });
    setResult({ ...result, data });
  };

  const exportToExcel = () => {
    if (_exporter.current) {
      _exporter.current.save();
    }
  };

  const updateUsingExcel = () => {
    setUploadExcelShow(!uploadExcelShow);
  };

  const onFileChange = (event) => {
    var uploadedFile = event.target.files[0];
    var filename = uploadedFile.name;
    setSelectedFile(filename);

    let reader = new FileReader();
    let file = event.target.files[0];

    reader.onloadend = () => {
      var Filedata = "";
      var bytes = new Uint8Array(reader.result);
      for (var i = 0; i < bytes.byteLength; i++) {
        Filedata += String.fromCharCode(bytes[i]);
      }
      var base64Data = window.btoa(Filedata);
      setFileData(Filedata);
      setBase64Data(base64Data);
    };

    reader.readAsArrayBuffer(file);
  };

  const uploadFile = () => {
    setUploadExcelShow(!uploadExcelShow);
    var workbook = read(fileData, {
      type: "binary",
    });
    console.log(workbook);
    var inputObj = {
      filename: selectedFile,
      content: base64Data,
      SCAC: scacSelected.text,
    };
    var response = uploadExcel(inputObj);
  };

  const uploadExcel = async (input) => {
    const response = await BulkUploadData(input);
    
    let typeError = false;
    let typeErrorMessage = "";
    response.forEach((data) => {
      if (data["TYPE"] === "E") {
        typeError = true;
        typeErrorMessage = data["MESSAGE"];
      }
    });

    if (typeError === true) {
      toast.error(typeErrorMessage,{theme:"colored"});
    }
    
    if (typeError === false) {
      toast.success("File uploaded successfully",{theme:"colored"});
    }
    refreshTableData();
  };

  const enterEdit = (dataItem) => {
    let _data = result.data.map((item) =>
      item.HAWB === dataItem.HAWB ? { ...item, inEdit: true } : item
    );

    setResult({ ...result, data: _data });
  };

  const cancel = (dataItem) => {
    const _item = initialPropsDateModified.find(
      (p) => p.HAWB === dataItem.HAWB
    );
    const newData = result.data.map((item) =>
      item.HAWB === _item.HAWB ? { ..._item, inEdit: false } : item
    );

    setResult({ ...result, data: newData });
  };

  const itemChange = (event) => {
    const newData = result.data.map((item) =>
      item.HAWB === event.dataItem.HAWB
        ? { ...item, [event.field || ""]: event.value }
        : item
    );
    setResult({ ...result, data: newData });
  };

  //  ---------------------- VALIDATING ----------------------
  function isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  function isValidTime(d) {
    return d !== "";
  }

  function isValidWeight(w) {
    return w !== null;
  }

  const validateMWABData = (mawb) => {
    let text = mawb;
    let pattern = /(^[a-zA-Z0-9])([a-zA-Z0-9- ])+([a-zA-Z0-9])$/gm;
    let result = pattern.test(text);
    if (!result) {
      toast.error(
        "Allowed Special character is space and hyphen only between MAWB Letters, not at the begin and end of MAWB no"
      );
      return false;
    }
    return true;
  };

  //  ---------------------- VALIDATING ----------------------

  //  ---------------------- RETRIGGER ----------------------
  const retrigger = async () => {
    let selectedItems = result.data
      .filter((elem) => elem["selected"])
      .map((ele) => ({ TRXID: ele["TRXID"] }));
    setBlock(true);
    let response = await retriggerItems(selectedItems);
    setBlock(false);
    if (response.filter((ele) => ele["TYPE"] === "E").length > 0) {
      toast.error("Something went wrong, try again",{theme:"colored"});
    } else {
      toast.success("Retrigged successfully",{theme:"colored"});
    }
  };
  //  ---------------------- RETRIGGER ----------------------

  const saveAllItems = async () => {

    let differenceArray = [];

    let data = result.data;

    for (let i = 0; i < data.length; i++) {
      let dataItem = data[i];
      if (dataItem.inEdit === true) {
        if (!validateMWABData(dataItem["MAWB"])) {
          return;
        }

        // console.log("Date")
        // console.log(isValidDate(dataItem['ETA_DT_XD']))
        // console.log("Time")
        // console.log(isValidDate(dataItem['ETA_TM_XD']))

        if (!isValidDate(dataItem["ETA_DT_XD"])) {
          toast.error("Invalid date",{ theme:"colored"   });
          return;
        }

        if (!isValidTime(dataItem["ETA_TM_XD"])) {
          toast.error("Invalid time",{ theme:"colored"   });
          return;
        }

        if (!isValidWeight(dataItem["WGT"])) {
          toast.error("Weight Record is Missing",{ theme:"colored"   });
          return;
        }

        dataItem.inEdit = false;

        let changedObj = initialPropsDateModified.filter(
          (elem) => elem["TRXID"] === dataItem["TRXID"]
        )[0];
        let difference = diff(changedObj, dataItem);
        difference = { TRXID: changedObj["TRXID"], ...difference };

        // Check if WT Unit is passed from server
        let tempObjToCheckIfWtUnitPresent = propsData.filter(
          (elem) => elem["TRXID"] === changedObj["TRXID"]
        )[0];
        if (!tempObjToCheckIfWtUnitPresent["WGT_TYPE"]) {
          difference = { ...difference, WGT_TYPE: "KG" };
        }

        // console.log(dayjs(dataItem['ETA_DT_XD']).format('MM/DD/YYYY'))
        // console.log(dayjs(dataItem['ETA_TM_XD']).format('HH:MM:SS'))

        if ("ETA_TM_XD" in difference || "ETA_DT_XD" in difference) {
          difference["ETA_TM_XD"] = dayjs(dataItem["ETA_TM_XD"]).format(
            "HH:mm:000"
          );
          dataItem["ETA_TM_XD"] = dayjs(dataItem["ETA_TM_XD"]).format(
            "HH:mm:000"
          );
          difference["ETA_DT_XD"] = dayjs(dataItem["ETA_DT_XD"]).format(
            "YYYY-MM-DD"
          );
          dataItem["ETA_DT_XD"] = dayjs(dataItem["ETA_DT_XD"]).format(
            "YYYY-MM-DD"
          );
        }

        let { inEdit, ...rest } = difference;

        differenceArray.push(rest);
      }
    }
    setBlock(true);

    const newData = await updateItem(differenceArray);

    let typeError = false;
    let typeErrorMessage = "";
    newData.forEach((data) => {
      if (data["TYPE"] === "E"  || data["TYPE"] === "S" || data["TYPE"] === "W") {
        typeError = true;
        typeErrorMessage = data["MESSAGE"];
      }
    });

    if (typeError === true) {
      toast.error(typeErrorMessage,{ theme:"colored" });
    }
    
    if (typeError === false) {
      toast.success("Record saved successfully",{ theme:"colored"   });
    }
    refreshTableData();
    setBlock(false);

  };

  const setTimeZoneValueFunction = (destinationPort) => {
    let temp = {[destinationPort['INTLOCID1']]: destinationPort['TZONE']}
    let tempTimeZoneValue = timeZoneValue.filter((elem) => Object.keys(elem)[0] !== destinationPort['INTLOCID1']);
    setTimeZoneValue([...tempTimeZoneValue, temp]);
  }

  const CommandCell = (props) => (
    <MyCommandCell
      {...props}
      edit={enterEdit}
      cancel={cancel}
      editField={editField}
    />
  );

  const LocalDropDownTimeZoneCell = (props) => (
    <DropDownTimeZoneCell {...props} timeZoneList={timeZoneList} timeZoneValue={timeZoneValue} />
  );

  const LocalDropDownTimePicker = (props) => <DropDownTimePicker {...props} />;

  const LocalETADTXDDatePicker = (props) => <ETADTXDDatePicker {...props} />;
  const DestinationPortDropdown = (props) => (
    <DropDownDestinationPort
      {...props}
      destinationDropdownList={destinationDropdownList}
      setTimeZone={setTimeZoneValueFunction}
    />
  );

  return (
    result && (
      <div id="xdockReport" className="xdockReport">
        {/* <BlockUi */}
          {/* tag="div"
          blocking={block}
          loader={
            <div>
              <Spinner animation="border" variant="info" />
            </div>
          }
        > */}
          <MDBContainer fluid>
            <MDBRow>
              <MDBCol sm="12" className="titleBox">
                <label>CROSS DOCK ETA</label>
              </MDBCol>
            </MDBRow>
          </MDBContainer>

          <br />
          <br />
          <Grid
            style={{
              height: "500px",
            }}
            data={result}
            filterable
            pageable
            total={result.length}
            // EDITING
            editField={editField}
            onItemChange={itemChange}
            // SELECTION
            onDataStateChange={onDataStateChange}
            selectedField="selected"
            onSelectionChange={selectionChange}
            onHeaderSelectionChange={headerSelectionChange}
            {...dataState}
          >
            <GridToolbar>
              <button
                className="download_File"
                title="Back"
                onClick={backToRearch}
              >
                <i className="fas fa-arrow-alt-circle-left backButton"></i>
                <span style={{ marginLeft: "8px" }}> Go-back</span>
              </button>

              <button
                className="download_File"
                onClick={exportToExcel}
                title={"Download data to Excel"}
              >
                <i className="material-icons">file_download</i>
                <span style={{ marginLeft: "8px" }}> Download </span>
              </button>

              {/* ------------ UPLOAD ------------ */}
              {!uploadExcelShow && (
                <button
                  title="Upload data from Excel"
                  className="download_File"
                  onClick={updateUsingExcel}
                >
                  <i className="material-icons">file_upload</i>
                  <span style={{ marginLeft: "8px" }}> Upload</span>
                </button>
              )}
              {uploadExcelShow && (
                <>
                  <div style={{ border: "1px solid black" }}>
                    <input
                      type="file"
                      id="fileUpload"
                      onChange={onFileChange}
                    ></input>
                    <button
                      className="k-button k-button-md k-rounded-md k-button-solid fileUpload"
                      onClick={uploadFile}
                    >
                      Upload
                    </button>
                  </div>
                </>
              )}
              {/* ------------ UPLOAD ------------*/}

              {/* ------------ SAVE ------------ */}
              <button className="download_File" onClick={saveAllItems}>

                <i className="material-icons">save</i>

                <span  style={{ marginLeft: "8px" }}> Save </span>

              </button>
              {/* ------------ SAVE ------------ */}

              {/* ------------ RETRIGGER ------------ */}
              { userDetails && userDetails.ROLE_LIST && userDetails.ROLE_LIST.XDMAWBETA && userDetails.ROLE_LIST.XDMAWBETA.CAR == "False" && (<button className="download_File" onClick={retrigger}>
                <span> Retrigger </span>
              </button>)}
              {/* ------------ RETRIGGER ------------ */}
            </GridToolbar>
            <Column
              field="selected"
              width="50px"
              filterable={false}
              headerSelectionValue={
                result.data.findIndex(
                  (dataItem) => dataItem.selected === false
                ) === -1
              }
            />
            <Column cell={CommandCell} width="110px" filterable={false} />
            <Column
              field="HAWB"
              title="HAWB"
              width="220px"
              editor="text"
              editable={false}
            />
            <Column
              field="SCAC"
              title="SCAC"
              width="150px"
              editor="text"
              editable={false}
            />
            <Column field="MAWB" title="MAWB" width="220px" editor="text" />
            <Column
              field="DES_LOC_PORT"
              title="Destination Port"
              width="150px"
              // editor="text"
              cell={DestinationPortDropdown}
            />
            <Column
              field="ETA_DT_XD"
              title="XD ETA Date"
              width="190px"
              // editor="date"
              // format="{0:MM/dd/yyyy}"
              cell={LocalETADTXDDatePicker}
              filterable={false}
              headerCell={EtaDtXdHeader}
            />
            <Column
              field="ETA_TM_XD"
              title="XD ETA Time"
              width="170px"
              cell={LocalDropDownTimePicker}
              filterable={false}
              headerCell={EtaTmXdHeader}
            />
            <Column
              field="TZONE"
              title="TimeZone"
              width="180px"
              cell={LocalDropDownTimeZoneCell}
            />
            <Column field="WGT" title="Weight" width="160px" editor="numeric" />
            <Column
              field="WGT_TYPE"
              title="WT Unit"
              width="80px"
              filterable={false}
              editable={false}
            />
            <Column
              field="REMARKS"
              title="Remarks"
              width="220px"
              editor="text"
            />
          </Grid>
          {<ExportData ref={_exporter} data={initialPropsDateModified} />}
        {/* </BlockUi> */}
      </div>
    )
  );
}

export default XDOCKReportNew;
